'use client';

import { type FlexProps } from '@ironhack/design-system2';
import { type ReactElement } from 'react';

import { Carousel } from '@/app/components/client/carousel';
import { type CardCarouselCardList } from '@/app/components/client/card-carousel';
import { UserCard } from '@/app/components/client/user-card';
import {
  type DatoAlumni,
  type DatoImage,
  type DatoModuleFormat,
  type DatoUserCardBlock,
} from '@/lib/datocms/types';

export type AlumniList = {
  alumni: DatoAlumni[];
  subtitle: string;
  title: string;
};

type Props = { data: AlumniList } & FlexProps;

export const AlumniList = (props: Props): ReactElement => {
  const {
    data: { alumni = [], subtitle, title },
    ...flexProps
  } = props;

  const cards = alumni.map(
    ({
      company: { horizontalTransparentLogo },
      ...alum
    }: DatoAlumni): DatoUserCardBlock => ({
      logos: [horizontalTransparentLogo as DatoImage],
      ...alum,
    })
  );

  const carouselData = {
    cardComponent: UserCard,
    cards: [{ cards }] as [CardCarouselCardList<DatoUserCardBlock>],
    moduleFormat: [
      { background: 'light', spacingBottom: '40', spacingTop: '40' },
    ] as [DatoModuleFormat],
    subtitle,
    title,
  };

  return <Carousel as="section" data={carouselData} {...flexProps} />;
};
